<div class="w-100 h-100 ubuntu-sans">
    <ul class="configs w-100 h-100 espacamento-cards">
        @for (configuracao of configuracoes; track $index) {
        <li>
            <button 
                card 
                [attr.hover]="!configuracao.desabilitada" 
                [disabled]="configuracao.tela == 'alimentadora' ? !temAlimentadora : configuracao.tela == 'falha-alerta' ?  !falhaAlertaDisponivel : configuracao.desabilitada"
                data-test-id="card-tela-configuracao"
                (click)="configuracao.tela == 'licenca' ? pedirLoginParaConfiguracaoDeLicenca() : irParaTelaConfig(configuracao.tela)">

                <div header>
                    <div class="d-flex align-items-center">
                        @switch (configuracao.tela) {
                            @case ('operacao') {
                                <object data="assets/agview-connect/sun.svg" type="image/svg+xml">
                                    {{ configuracao.descricaoIcone | transloco }}
                                </object>
                            }
                            @case ('licenca') {
                                <img src="assets/agview-connect/chave.png" [alt]="configuracao.descricaoIcone | transloco" />
                            }
                            @case ('alimentadora') {
                                <object data="assets/agview-connect/gears.svg" type="image/svg+xml">
                                    {{ configuracao.descricaoIcone | transloco }}
                                </object>
                            }
                            @case ('falha-alerta') {
                                <object data="assets/agview-connect/comment-exclamation.svg" type="image/svg+xml">
                                    {{ configuracao.descricaoIcone | transloco }}
                                </object>
                            }
                        }

                        <span>{{ configuracao.titulo | transloco }}</span>
                    </div>
                </div>
                <p>
                    {{ configuracao.descricao | transloco }}
                </p>
            </button>
        </li>
        }
    </ul>
</div>